import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { errMsg } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (e) {
      setErr(errMsg(e, "Email ou mot de passe incorrect"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-32 pb-20 max-w-md mx-auto px-6">
        <h1 className="text-3xl font-medium text-[#111827]">{t("login")}</h1>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2 block">{t("email")}</label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2 block">{t("password")}</label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
          <Button type="submit" disabled={busy} className="w-full bg-[#1B8F5A] hover:bg-[#157047] h-12" data-testid="login-submit">
            {busy ? "…" : t("login")}
          </Button>
          <p className="text-sm text-slate-600 text-center pt-2">
            {t("noAccount")} <Link to="/register" className="text-[#1B8F5A] font-semibold">{t("register")}</Link>
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
}
